import { Injectable } from '@angular/core';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';

/**
 * Tasks service.
 */
@Injectable()
export class MetricsService {

  constructor(private apolloService: ApolloService,
    ) {}

  /**
   * Completes TAsk
   * @param id Task Id
   * @param protocol protocol zu Complete Task
   */
  public publishTimeSeriesMetricEvent(metricName: string): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.PUBLISH_TIME_SERIES_METRIC_EVENT_MUTATION,
      {
        metricName
      },
      (result) => {
        // console.log(result);
      }
    );
  }


}
